
export default  mapBox = () => {

    
        const locationsStrg = document.querySelector('#map').dataset.locations;
        
    
        const locations = JSON.parse(locationsStrg);
        
        
    
        const map = L.map('map', {
            closePopupOnClick: false,
            zoomControl: false
        }) 
    
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map)
    
        const coords = [];
    
        for(const {coordinates, description, day} of locations){
            const [lng, lat] = coordinates;
            L.marker([lat, lng])
                .bindPopup(`${description} - Day ${day}`, {
                    maxWidth: 400,
                    minWidth: 200,
                    autoClose: false,
                    className: 'custom-large-popup'
    
                })
                .openPopup()
                .addTo(map);
                
                coords.push([lat, lng]);
        };
    
        const bounds = L.latLngBounds(coords).pad(0.5);
        map.fitBounds(bounds);  
        map.scrollWheelZoom.disable();
}